/* img/sourceタグに自動で幅と高さを入力 ※ページ内全てに実行
--------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function() {
  // ページが読み込まれた時に実行されるコード

  // <source>要素と <img>要素を全て取得
  var sourceElements = document.querySelectorAll('source');
  var imgElements = document.querySelectorAll('img');

  // 画像の幅と高さを取得して設定する関数
  function setImageSize(element, src) {
      var image = new Image();
      image.src = src; // 画像のパスを設定
      image.onload = function() {
          var width = this.width; // 画像の幅を取得
          var height = this.height; // 画像の高さを取得

          // width と height 属性を設定する
          element.setAttribute('width', width);
          element.setAttribute('height', height);
      };
  }

  // 各<source>要素に対して処理を行う
  sourceElements.forEach(function(sourceElement) {
      // srcset属性の値を取得し、最初の画像パスを取り出す
      var srcsetValue = sourceElement.getAttribute('srcset');
      if (srcsetValue) {
          var src = srcsetValue.split(' ')[0].trim(); // srcset の最初の値（画像パス）を取得
          setImageSize(sourceElement, src); // 幅と高さを設定
      }
  });

  // 各<img>要素に対して処理を行う
  imgElements.forEach(function(imgElement) {
      var src = imgElement.getAttribute('src'); // img の src 属性を取得
      if (src) {
          setImageSize(imgElement, src); // 幅と高さを設定
      }
  });
});

/* 空欄のaltにimageを自動入力 ※ページ内全てに実行
--------------------------------------------------------- */
// DOMが読み込まれた後に実行される部分
document.addEventListener('DOMContentLoaded', function() {
  // すべてのimgタグを取得する
  var images = document.querySelectorAll('img');

  // 各imgタグに対して処理を行う
  images.forEach(function(img) {
      // もしalt属性が空であれば、「image」というalt属性を設定する
      if (!img.alt) {
          img.alt = "image";
      }
  });
});

/* アコーディオン
--------------------------------------------------------- */
$(function(){
	$('.aco_open_btn').click(function(){
		$(this).toggleClass('active');
		$(this).next('.aco_content').slideToggle();
	});
});


/* ハンバーガーメニュー
--------------------------------------------------------- */
$(function () {
	$(".openbtn").click(function () { //ボタンがクリックされたら
		$(this).toggleClass('active'); //ボタン自身に activeクラスを付与し
		$(".g_nav").toggleClass('panelactive'); //ナビゲーションにpanelactiveクラスを付与
	});
	$('.g_nav a[href]').on('click', function(event) {
		$('.openbtn').trigger('click');
	});
});

$(function () {
  // ハンバーガーメニューボタンがクリックされたときのイベントハンドラを設定
  $(".openbtn").click(function () {
    // 現在のbodyタグのoverflowスタイルを確認
    if ($("body").css("overflow") === "hidden") {
      // もしoverflowがhiddenなら、bodyのスタイルを元に戻す
      $("body").css({ height: "", overflow: "" });
    } else {
      // そうでなければ、bodyにheight: 100%とoverflow: hiddenを設定し、スクロールを無効にする
      $("body").css({ height: "100%", overflow: "hidden" });
    }
  });
});

/* スムーススクロール
--------------------------------------------------------- */
$(document).ready(function(){
	$('a[href^="#"]').click(function(){
			var speed = 500;
			var href = $(this).attr("href");
			var target = $(href === "#" || href === "" ? 'html' : href);
			var position = target.offset().top;
			$("html, body").animate({scrollTop: position}, speed, "swing");
			return false;
	});
});

/* 20250623 追加--- */
/* Swiper
--------------------------------------------------------- */
const mySwiper = new Swiper('.swiper', {
	loop: true,
	spaceBetween: 17,
	slidesPerView: "auto",
	centeredSlides: true,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
});
/* ---20250623 追加 */
